import React from 'react';
import _ from 'lodash';

export default class Counter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFocused: false,
      hasValue: !!props.value,
    };

    this.getSelectedOption = this.getSelectedOption.bind(this);
    this.setControlState = this.setControlState.bind(this);
  }

  getSelectedOption = (selectedOpt, e) => {
    if (this.props.handleSelectedOption && this.props.optionValue) {
      const _selectedOption = this.props.options.filter(
        option => option[this.props.optionValue].toString() === selectedOpt
      );
      if (this.props.id && _selectedOption.length > 0) {
        _selectedOption[0].senderId = this.props.id;
      } else if (_selectedOption.length === 0) {
        _selectedOption.push(selectedOpt);
      }
      this.setState({ hasValue: !!selectedOpt });
      this.props.handleSelectedOption(_selectedOption[0], e);
    }
  };

  clearSelectedData() {
    if (this.selectedOption) {
      this.selectedOption.selectedIndex = '';
      this.setState({ hasValue: false });
    }
  }

  getValue() {
    if (this.selectedOption.selectedIndex) {
      return this.selectedOption.value;
    }
    return '';
  }

  getSelectedText() {
    return this.selectedOption.options[this.selectedOption.selectedIndex].innerText;
  }

  getID() {
    if (
      this.selectedOption &&
      this.selectedOption.options &&
      this.selectedOption.options.length
    ) {
      return this.selectedOption.options[this.selectedOption.selectedIndex].id;
    }
    return null;
  }

  getSelectedIndex() {
    return this.selectedOption.selectedIndex;
  }

  setSelectedValue = newvalue => {
    const slectedOption = document.querySelector('[id="' + newvalue + '"]');
    if (slectedOption) {
      slectedOption.selected = true;
      this.setState({ hasValue: true });
    }
  };

  setControlState(isValildState, errorMessage, errorAttributes) {
    this.isControlStateValid = isValildState;
 
    if (
      isValildState &&
      ((this.props.isMandatory && this.selectedOption.value) ||
        !this.props.isMandatory)
    ) {
      this.selectedOption.classList.remove(errorAttributes.controlErrorClass);
      this.errorControl.classList.remove(errorAttributes.errorClass);
      this.errorControl.style.display = 'none';
      this.errorControl.innerHTML = '';
    } else {
      // if(!this.props.src){
      this.selectedOption.classList.add(errorAttributes.controlErrorClass);
      this.errorControl.classList.add(errorAttributes.errorClass);
      this.errorControl.innerHTML = errorMessage
      // };
      this.errorControl.style.display = 'block';
    }
  }

clearError() {
  if (this.errorControl) {
    this.errorControl.style.display = 'none';
    this.errorControl.innerHTML = '';
    if (this.selectedOption) {
      this.selectedOption.classList.remove('error');
    }
  }
}


  render() {
    const props = this.props;
    const {
      optionText,
      optionValue,
      optionCaption,
      value,
      disable,
      id,
      dropDownClass,
      classname,
      isCaptionDisabled,
      iconname,
      sortOptions,
      style,
      styleError,
      src,
      label,
    } = this.props;

    let { options } = this.props;
    let optionHtml = [];
    let optionCaptionHtml;

    if (optionCaption !== undefined) {
      const optionProps = {
        selected: 'selected',
        key: '0caption' + props.id,
      };
      optionProps.disabled = isCaptionDisabled !== undefined ? isCaptionDisabled : true;
      optionCaptionHtml = <option {...optionProps}>{optionCaption}</option>;
    }

    if (options) {
      if (sortOptions) {
        options = _.sortBy(options, optionText);
      }
      optionHtml = options.map((option, index) => (
        <option
          disabled={option.disabled}
          id={option.id}
          key={index + 'option' + props.id}
          selected={optionValue ? value === option[optionValue] : false}
          value={optionValue ? option[optionValue] : ''}
        >
          {option[optionText]}
        </option>
      ));

      if (optionCaptionHtml) {
        optionHtml.unshift(optionCaptionHtml);
      }
    } else if (optionCaptionHtml) {
      optionHtml = [optionCaptionHtml];
    }

    let classValue = iconname || 'icon-caret_down';
    const { isFocused, hasValue } = this.state;

    return (
      <React.Fragment>
        <div className={`floating-select-wrapper ${classname || ''} select-border-none`} style={style}>
          <div className="floating-label-container">
            <label
              htmlFor={id}
              className={`floating-label ${isFocused || hasValue ? 'float' : ''}`}
            >
              {optionCaption || 'Select'} <span className='arsterik'>*</span>
            </label>
            <select
              id={id}
              disabled={disable}
              onChange={e => this.getSelectedOption(e.target.value, e)}
              onFocus={() => this.setState({ isFocused: true })}
              onBlur={() => this.setState({ isFocused: false })}
              ref={sel => (this.selectedOption = sel)}
              className={`native-select native-select-custom ${dropDownClass || ''}`}
              style={{ marginBottom: '0px', color: disable ? '#b3b3b3' : 'inherit' }}
            >
              {optionHtml}
            </select>
            {disable ? null : src ? (
              <img src={src} className="arrow_down_img" />
            ) : (
              <i className={classValue} />
            )}
          </div>
        </div>
        {this.props.requiredLabel && (
          <p style={{ margin: '4px 12px 10px 0', fontSize: 12, color: '#a1a1a1' }}>
            {this.props.requiredLabel}
          </p>
        )}
        <label
          className="error"
          style={styleError}
          ref={err => (this.errorControl = err)}
        />
      </React.Fragment>
    );
  }
}

Counter.defaultProps = {
  isMandatory: true,
};
